module.exports = __webpack_public_path__ + "static/media/software-development-engineer.d8caa1df.png";